module.exports = {
          srcSet: __webpack_public_path__ + "public/images/aafafdf08cc64b844a410d3f1d12e7db-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/aafafdf08cc64b844a410d3f1d12e7db-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/aafafdf08cc64b844a410d3f1d12e7db-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/aafafdf08cc64b844a410d3f1d12e7db-1774.jpg"},
          
          width: 1774,
          height: 887
        }